import React, { useState, useEffect } from "react";
import "./faq-section.m.css";
import { PlusIcon } from "./plus-icon";
import { MinusIcon } from "./minus-icon";
import { SUBSCRIPTION_PAGE_STRINGS } from "../../../../constants";
import { optimizeImageUrl } from "../utils";

const FaqSection = ({ colors = {}, fetchUrl = "/subscribe-faq" }) => {
  const s = SUBSCRIPTION_PAGE_STRINGS.DH, [openIndices, setOpenIndices] = useState([]), [items, setItems] = useState([]);
  useEffect(() => { fetch(fetchUrl).then(res => res.json()).then(d => setItems(d?.faq_section?.faqs || d?.faqs || d?.items || [])).catch(() => {}); }, []);
  if (!items.length) return null;

  return (
    <section styleName="faq-section">
      <h2 styleName="heading" style={colors.text_color ? { color: colors.text_color } : {}}>{s.FAQ_HEADING}</h2>
      <div styleName="faq-container">
        {items.map((item, i) => {
          const isOpen = openIndices.includes(i);
          return (
            <div key={item.id || i} styleName="faq-item">
              <div styleName="question-row">
                <span styleName="question-text" style={colors.text_color ? { color: colors.text_color } : {}}>{item.question || item.title || ""}</span>
                <button type="button" styleName="icon-wrap" onClick={() => setOpenIndices(prev => prev.includes(i) ? prev.filter(idx => idx !== i) : [...prev, i])} aria-expanded={isOpen} aria-controls={`faq-answer-${i}`} aria-label="Toggle answer" style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}>
                  {isOpen ? <MinusIcon color={colors.palette2} /> : <PlusIcon color={colors.palette2} />}
                </button>
              </div>
              <div id={`faq-answer-${i}`} styleName="answer-wrap" style={{ maxHeight: isOpen ? "500px" : "0px" }}>
                <div styleName="answer" style={colors.text_color ? { color: colors.text_color } : {}}>
                  <span>{item.answer || item.description || ""}</span>
                  {item.img && <img src={optimizeImageUrl(item.img, 100)} alt="" styleName="faq-img" style={{ ...(item.img_width ? { width: isNaN(item.img_width) ? item.img_width : `${item.img_width}px` } : {}), ...(item.img_height ? { height: isNaN(item.img_height) ? item.img_height : `${item.img_height}px` } : {}) }} />}
                </div>
              </div>
              {i < items.length - 1 && <div styleName="separator" style={{ backgroundColor: colors.palette2 }} />}
            </div>
          );
        })}
      </div>
    </section>
  );
};
export { FaqSection };
